export default [
  {
    itemType: 'group',
    colCount: 1,
    items: [
      {
        dataField: 'grupo',
        label: { text: 'Descrição' },
        validationRules: [{
          type: 'required',
          message: 'Descrição é obrigatório'
        }]
      },
      {
        dataField: 'sincronizado',
        label: { text: 'Sincronizado' },
        editorType: 'dxSelectBox',
        editorOptions: {
          items: [
            { value: 'S', label: 'Sim' },
            { value: 'N', label: 'Não' }
          ],
          displayExpr: 'label',
          valueExpr: 'value'
        }
      }
    ]
  }
]
